import { Field, ErrorMessage } from 'formik';

export default function ContactStep({ finalInterestOptions }) {
  return (
    <div className="space-y-6 !text-left">
      <div className="mb-4">
        <p className="mb-2 text-xl font-medium text-gray-700">Request Type:</p>
        <div className="mobile:flex-row flex flex-col gap-4">
          <label className="flex items-center">
            <Field
              type="radio"
              name="requestType"
              value="Appointment Request"
              className="mr-2"
            />
            <span>Appointment Request</span>
          </label>
          <label className="flex items-center">
            <Field
              type="radio"
              name="requestType"
              value="Estimate Request"
              className="mr-2"
            />
            <span>Estimate Request</span>
          </label>
        </div>
      </div>
      <hr />
      <h2 className="mb-4 text-xl font-medium text-gray-700">
        Contact Information &amp; Services
      </h2>
      <div>
        <label
          htmlFor="firstName"
          className="block text-sm font-medium text-gray-700"
        >
          First Name<span className="text-red-500">*</span>
        </label>
        <div className="flex space-x-4">
          <Field
            type="text"
            id="firstName"
            name="firstName"
            placeholder="John"
            className="mt-1 block w-full rounded-md border-gray-300 px-3 py-2"
          />
          <Field
            type="text"
            id="lastName"
            name="lastName"
            placeholder="Doe"
            className="mt-1 block w-full rounded-md border-gray-300 px-3 py-2"
          />
        </div>
        <div className="flex justify-between">
          <ErrorMessage
            name="firstName"
            component="div"
            className="mt-1 text-xs text-red-500"
          />
          <ErrorMessage
            name="lastName"
            component="div"
            className="mt-1 text-xs text-red-500"
          />
        </div>
      </div>
      <div className="mt-4">
        <label
          htmlFor="phone"
          className="block text-sm font-medium text-gray-700"
        >
          Phone<span className="text-red-500">*</span>
        </label>
        <Field
          type="text"
          id="phone"
          name="phone"
          placeholder="123-456-7890"
          className="mt-1 block w-full rounded-md border-gray-300 px-3 py-2"
        />
        <ErrorMessage
          name="phone"
          component="div"
          className="mt-1 text-xs text-red-500"
        />
      </div>
      <div className="mt-4">
        <label
          htmlFor="email"
          className="block text-sm font-medium text-gray-700"
        >
          Email<span className="text-red-500">*</span>
        </label>
        <Field
          type="email"
          id="email"
          name="email"
          placeholder="john@mail.com"
          className="mt-1 block w-full rounded-md border-gray-300 px-3 py-2"
        />
        <ErrorMessage
          name="email"
          component="div"
          className="mt-1 text-xs text-red-500"
        />
      </div>
      <div className="mt-6">
        <p className="mb-2 text-sm font-medium text-gray-700">
          I am interested in: <span className="text-red-500">*</span>
        </p>
        <div className="space-y-2">
          {finalInterestOptions.map((option, i) => (
            <div key={i} className="flex items-center">
              <Field name="mainInterest">
                {({ field, form }) => {
                  const isChecked = field.value.includes(option);
                  return (
                    <input
                      type="checkbox"
                      value={option}
                      checked={isChecked}
                      onChange={(e) => {
                        const newValue = e.target.checked
                          ? [...field.value, option]
                          : field.value.filter((v) => v !== option);
                        form.setFieldValue('mainInterest', newValue);
                      }}
                      className="mr-3"
                    />
                  );
                }}
              </Field>
              <span className="text-gray-700">{option}</span>
            </div>
          ))}
          <ErrorMessage
            name="mainInterest"
            component="div"
            className="mt-1 text-xs text-red-500"
          />
          <p className="text-xs italic">**You may select more than one</p>
        </div>
      </div>
    </div>
  );
}
